<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Cupons">
    <Edit
      :dimensoes="dimensoes"
      :clientes="clientes"
      :produtos="produtos"
      :item="currentItem"
      :update="updateItem"
      :close="closeEdit"
      :error="modalError"
      :descSingular="descSingular"
    />
    <Loading :isActive="loading" />
    <Historico :historico="historico" :close="closeInfo" />

    <div class="toolbar-card">
      <div class="toolbar-filters">
        <div class="filter-group">
          <label class="field-label">Código</label>
          <input
            class="form-control form-control-sm"
            type="text"
            v-model="filtros.codigo"
            placeholder="Buscar por código"
          />
        </div>
        <div class="filter-group">
          <label class="field-label">Status</label>
          <select class="form-control form-control-sm" v-model="filtros.status">
            <option value="TODOS">Todos</option>
            <option value="NAO_UTILIZADO">Não Utilizados</option>
            <option value="UTILIZADO">Já Utilizados</option>
          </select>
        </div>
        <div class="filter-group">
          <label class="field-label">Dt. inicial</label>
          <datetime
            input-class="form-control form-control-sm"
            v-model="filtros.dtIni"
            type="date"
            v-on:input="loadCupons"
            placeholder="Data inicial"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
          />
        </div>
        <div class="filter-group">
          <label class="field-label">Dt. final</label>
          <datetime
            input-class="form-control form-control-sm"
            v-model="filtros.dtFim"
            type="date"
            v-on:input="loadCupons"
            placeholder="Data final"
            :phrases="{ ok: 'Confirmar', cancel: 'Fechar' }"
            value-zone="local"
          />
        </div>
        <div class="filter-group filter-group--actions">
          <CButton color="primary" size="sm" @click="loadCupons">
            <fa-icon icon="search" /> Buscar
          </CButton>
        </div>
      </div>
      <div class="toolbar-actions">
        <CButton color="success" size="sm" @click="openCreate">
          <fa-icon icon="plus" /> Criar {{ descSingular }}
        </CButton>
      </div>
    </div>

    <div class="table-card">
      <div class="table-responsive">
        <table class="table table-hover table-sm">
          <thead>
            <tr>
              <th>Id</th>
              <th>Código</th>
              <th>Tipo Desc.</th>
              <th>Valor</th>
              <th>Clientes</th>
              <th>Limite p/ Cliente</th>
              <th>Usados</th>
              <th>Validade</th>
              <th>Status</th>
              <th class="text-right">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="td-id">{{ item.id }}</td>
              <td><code class="codigo-badge">{{ item.codigo }}</code></td>
              <td>{{ tiposDesconto()[item.tipoDesconto].label }}</td>
              <td v-if="item.tipoDesconto === 'F'">{{ toMonetary(item.valor) }}</td>
              <td v-else>{{ item.valor }}%</td>
              <td v-if="item.validarCliente">{{ item.clientes.length }} cliente(s)</td>
              <td v-else><span class="text-muted">Todos</span></td>
              <td>{{ item.limiteUsos }}</td>
              <td>{{ item.usados }}</td>
              <td>
                <span class="date-range">
                  {{ toDateTime(item.dataInicio) }} - {{ toDateTime(item.dataFim) }}
                </span>
              </td>
              <td>
                <span
                  class="status-badge"
                  :class="{
                    'status-badge--ativo': item.status === 'ATIVO',
                    'status-badge--vencido': item.status === 'VENCIDO',
                  }"
                >
                  {{ item.status }}
                </span>
              </td>
              <td class="td-actions">
                <CButton
                  size="sm"
                  color="info"
                  variant="ghost"
                  :disabled="!item.usados"
                  @click="openInfo(item)"
                  title="Histórico de uso"
                >
                  <fa-icon icon="info-circle" />
                </CButton>
                <CButton
                  size="sm"
                  color="success"
                  variant="ghost"
                  @click="cloneCupom(item)"
                  title="Clonar"
                >
                  <fa-icon icon="clone" />
                </CButton>
                <CButton
                  size="sm"
                  color="primary"
                  variant="ghost"
                  @click="openEdit(item)"
                  title="Editar"
                >
                  <fa-icon icon="pencil-alt" />
                </CButton>
                <CButton
                  size="sm"
                  color="danger"
                  variant="ghost"
                  @click="deleteConfirm(item.id)"
                  title="Excluir"
                >
                  <fa-icon icon="trash-alt" />
                </CButton>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <EmptyState
        v-if="!items.length && !loading"
        icon="ticket-alt"
        title="Nenhum cupom encontrado"
        description="Altere os filtros ou crie um novo cupom"
      />
    </div>
    </CTab>
  </CTabs>
</template>

<script>
import clone from "just-clone";
import { get, post, put, del } from "@/helpers/apiRequest";
import { toMonetary, toPercent, toDateTime } from "../../helpers/utils";
import _map from "lodash/map";
import moment from "moment";
import Edit from "./Edit";
import Historico from "./Historico";
import EmptyState from "../../components/EmptyState";

const initial = {
  codigo: "",
  orientacao: "",
  tipoDesconto: "F",
  tipoRegra: "P",
  tipoIntegracao: "CREDITO",
  valor: "1.00",
  dataInicio: moment().format(),
  clientes: [],
  produtos: [],
  regras: [],
  exclusoes: [],
  B2B: false,
  CALLCENTER: false,
  FORCA_VENDAS: false,
  dataFim: moment().add(1, "days").format(),
  ativo: 1,
  validarCliente: false,
  limiteUsos: "1",
  limiteusos_geral: null,
  valor_maximo_permitido: "1.00",
  aplica_sobre_imposto: 1,
  aplica_sobre_promocao: 0,
  valida_valor_minimo_plano: 1,
};

export default {
  name: "cupons",
  components: {
    Edit,
    Historico,
    EmptyState,
  },
  data() {
    return {
      descPlural: "",
      descSingular: "",
      loading: false,
      items: [],
      clientes: [],
      produtos: [],
      dimensoes: [],
      filtros: {
        dtIni: moment().format("YYYY-MM-DD"),
        dtFim: moment().format("YYYY-MM-DD"),
        status: "TODOS",
        codigo: "",
      },
      currentItem: { ...initial },
      currentAccess: false,
      modalError: null,
      historico: null,
    };
  },
  methods: {
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem("app"));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === "ADMIN_CUPOM"
      );
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    setStatus({ loading, error }) {
      this.loading = loading;
      this.modalError = error;
    },
    resetStatus() {
      this.loading = false;
      this.modalError = null;
    },
    loadCupons() {
      this.loading = true;
      const dataIniFormat = moment(this.filtros.dtIni).format("YYYY-MM-DD");
      const dataFimFormat = moment(this.filtros.dtFim).format("YYYY-MM-DD");

      get(
        `/admin/cupons?dtIni=${dataIniFormat}&dtFim=${dataFimFormat}&status=${this.filtros.status}&codigo=${this.filtros.codigo}`
      )
        .then((json) => {
          this.items = this.midllewareCupons(json);
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    midllewareCupons(cupons) {
      return _map(cupons, (i) => {
        return {
          ...i,
          dataInicio: moment(i.dataInicio).format(),
          dataFim: moment(i.dataFim).format(),
        };
      });
    },
    loadClientes() {
      this.loading = true;
      get("/admin/cupons-clientes")
        .then((array) => {
          this.clientes = array;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadProdutos() {
      this.loading = true;
      get("/admin/cupons-produtos")
        .then((array) => {
          this.produtos = array;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    loadDimensoes() {
      this.loading = true;
      get("/admin/cupons-dimensoes")
        .then((json) => {
          this.dimensoes = json;
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    cloneCupom(cupom) {
      const cloneCupom = clone(cupom);

      cloneCupom.id = null;
      cloneCupom.codigo = null;

      this.openEdit(cloneCupom);
    },
    createItem(item) {
      const payload = { ...item };
      const idClientes = _map(payload.clientes, 'id');
      payload.clientes = idClientes;

      this.loading = true;
      post("/admin/cupons", payload)
        .then((json) => {
          this.$swal({
            title: "Sucesso!",
            text: "Cupom cadastrado com sucesso!",
            icon: "success",
          });
          this.closeEdit();
          this.resetStatus();
          this.loadCupons();
        })
        .catch((error) => {
          this.setStatus({ loading: false, error });

          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
    },
    openInfo(item) {
      if (!item.usados) {
        return;
      }

      this.loading = true;
      get(`/admin/cupons/${item.id}/historico`)
        .then((json) => {
          this.historico = json;
          this.$modal.show("cupomHistorico");
        })
        .catch((err) => console.log(`Erro ao carregar histórico: ${err}`))
        .finally(() => (this.loading = false));
    },
    closeInfo() {
      this.$modal.hide("cupomHistorico");
    },
    openCreate() {
      this.currentItem = { ...initial };
      this.currentItem.clientes = [];

      this.$modal.show("cupomEdit");
      this.modalError = null;
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.$modal.show("cupomEdit");
      this.modalError = null;
    },
    closeEdit() {
      this.$modal.hide("cupomEdit");
      this.modalError = null;
    },
    updateItem() {
      this.loading = true;
      const { id } = this.currentItem;
      const payload = { ...this.currentItem };
      const idClientes = _map(payload.clientes, 'id');
      payload.clientes = idClientes;

      if (id) {
        put(`/admin/cupons/${id}`, payload)
          .then((json) => {
            this.$swal({
              title: "Sucesso!",
              text: "Cupom alterado!",
              icon: "success",
            });
            this.loading = false;
            this.loadCupons();
            this.closeEdit();
          })
          .catch((error) => {
            this.setStatus({ loading: false, error });

            this.$swal({
              title: "Falha ao Salvar",
              text: error.message,
              showCancelButton: true,
              cancelButtonText: "Fechar",
              showConfirmButton: false,
              icon: "error",
            });
          });
      } else {

        this.createItem(this.currentItem);
      }
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/cupons/${id}`)
              .then((json) => {
                this.loading = false;
                this.loadCupons();
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: "Falha ao remover",
                  icon: "error",
                });
              });
          }
        })
        .catch(() => {});
    },
    tiposDesconto() {
      return {
        F: {
          label: "Fixo",
          symbol: "R$",
        },
        P: {
          label: "Percentual",
          symbol: "%",
        },
      };
    },
    toMonetary,
    toPercent,
    toDateTime,
  },
  beforeMount() {
    this.loadClientes();
    this.loadProdutos();
    this.loadCupons();
    this.loadDimensoes();
    this.loadDescricaoModulo();
  },
};
</script>

<style scoped>
.toolbar-card {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 0 0 16px;
  margin-bottom: 16px;
}

.toolbar-filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;
}

.filter-group {
  min-width: 140px;
}

.filter-group--actions {
  min-width: auto;
  align-self: flex-end;
}

.toolbar-card .form-control,
.toolbar-card >>> .vdatetime input {
  height: 31px !important;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.toolbar-card .btn {
  height: 31px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.table-card {
  background: #fff;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.table-card >>> .empty-state {
  margin: 20px;
}

.table-card .table {
  margin-bottom: 0;
}

.table-card .table thead th {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 14px;
  white-space: nowrap;
}

.table-card .table tbody td {
  padding: 10px 14px;
  font-size: 13px;
  color: #344054;
  vertical-align: middle;
}

.td-id {
  font-weight: 600;
  color: #3a3e81 !important;
}

.codigo-badge {
  font-size: 12px;
  color: #344054;
  background: #f2f4f7;
  padding: 2px 6px;
  border-radius: 4px;
}

.date-range {
  font-size: 12px;
  color: #667085;
  white-space: nowrap;
}

.status-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  display: inline-block;
}

.status-badge--ativo {
  background: #ecfdf3;
  color: #027a48;
  border: 1px solid #a6f4c5;
}

.status-badge--vencido {
  background: #fef3f2;
  color: #b42318;
  border: 1px solid #fecdca;
}

.td-actions {
  text-align: right;
  white-space: nowrap;
}

.td-actions .btn {
  padding: 4px 6px;
}

</style>
